import { MainAPiServiceService } from '@_services/main-api-service.service';
import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddStaffCostingsComponent } from '../add-staff-costings/add-staff-costings.component';
import { ToolbarServiceService } from 'src/app/layout/components/toolbar/toolbar-service.service';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-staff-costings',
  templateUrl: './staff-costings.component.html',
  styleUrls: ['./staff-costings.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StaffCostingsComponent implements OnInit {
  isLoadingResults: boolean = false;
  private _unsubscribeAll$: Subject<any> = new Subject();
  highlightedRows: any;
  selectedColore: string = 'var(--highlighted-bg-row)';
  USERSTAFFCOSTINGGUID: any;
  confirmDialogRef: MatDialogRef<any>;

  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
    public _matDialog: MatDialog,
    private toolbarServiceService: ToolbarServiceService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  displayedColumns: string[] = ['EFFECTIVEDATE', 'ANNUALBILLINGHOURS', 'COSTPERBILLINGHOUR'];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatSort) sort!: MatSort;

  ngAfterViewInit() {}

  loadData() {
    this.isLoadingResults = true;
    const User = JSON.parse(localStorage.getItem('current_user_Data'));
    this._mainAPiServiceService
      .getSetData(
        { Action: 'GetData', Filters: { USERGUID: User?.USERGUID } },
        'user-staff-annual-costing',
      )
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe(
        (response) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            if (response.DATA.RECORDS.length > 0) {
              this.highlightedRows = response.DATA.RECORDS[0].USERSTAFFCOSTINGGUID;
              this.USERSTAFFCOSTINGGUID = response.DATA.RECORDS[0].USERSTAFFCOSTINGGUID;
              this.dataSource.data = response.DATA.RECORDS;
              this.sortDate();
            }
            this.isLoadingResults = false;
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.isLoadingResults = false;
            this.toastr.warning(response.MESSAGE);
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.toastr.error(response.MESSAGE);
            this.isLoadingResults = false;
          } else if (response.MESSAGE == 'Not logged in') {
            this.isLoadingResults = false;
          }
          this.isLoadingResults = false;
        },
        (error) => {
          this.isLoadingResults = false;
          this.toastr.error(error);
        },
      );
  }

  sortDate() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      if (property === 'EFFECTIVEDATE') {
        const parts = item.EFFECTIVEDATE.split('/');
        return new Date(+parts[2], +parts[1] - 1, +parts[0]);
      }
      return item[property];
    };

    this.dataSource.sort = this.sort;
  }

  /**
   * This function is used to open the user dialog data.
   * @param actionType -this function is used to check the action type.
   * @returns -
   */
  Addstaffcost(actionType) {
    let popupData: any = {};
    const User = JSON.parse(localStorage.getItem('current_user_Data'));
    if (actionType == 'new') {
      popupData = { action: actionType, USERGUID: User?.USERGUID };
    } else if (actionType == 'edit') {
      popupData = {
        action: actionType,
        USERGUID: User?.USERGUID,
        USERSTAFFCOSTINGGUID: this.USERSTAFFCOSTINGGUID,
      };
    }
    const dialogRef = this._matDialog.open(AddStaffCostingsComponent, {
      width: DIALOG_WIDTH.W400,
      disableClose: true,
      panelClass: 'User-dialog',
      data: popupData,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadData();
      }
    });
  }

  getStafCostData(data) {
    this.USERSTAFFCOSTINGGUID = data?.USERSTAFFCOSTINGGUID;
  }

  deleteStafCost() {
    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
    });

    this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
    this.confirmDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let postData = {
          ACTION: 'delete',
          DATA: {
            USERSTAFFCOSTINGGUID: this.USERSTAFFCOSTINGGUID,
          },
        };
        this._mainAPiServiceService
          .getSetData(postData, 'user-staff-annual-costing')
          .subscribe((res) => {
            if (res.STATUS == 'success' && res.CODE == 200) {
              this.loadData();
              this.toastr.success('Deleted successfully');
            } else if (res.CODE == 451 && res.STATUS == 'warning') {
              this.checkValidation(res.DATA.VALIDATIONS, postData, 'user-staff-annual-costing');
            } else if (res.CODE == 450 && res.STATUS == 'error') {
              this.checkValidation(res.DATA.VALIDATIONS, postData, 'user-staff-annual-costing');
            } else if (res.MESSAGE == 'Not logged in') {
            }
          });
      }
      this.confirmDialogRef = null;
    });
  }

  /**
   * This function is used to check the validation data
   * @param bodyData -bodydata value
   * @param details -details value
   * @param ApiName -Api Name
   */
  async checkValidation(bodyData: any, details: any, ApiName: any) {
    let errorData: any = [];
    let warningData: any = [];
    let tempError: any = [];
    let tempWarning: any = [];

    bodyData.forEach((value: any) => {
      if (value.VALUEVALID == 'No' || value.VALUEVALID == 'NO' || value.VALUEVALID == 'Error') {
        errorData.push(value.ERRORDESCRIPTION);
        tempError[value.FIELDNAME] = value;
      } else if (value.VALUEVALID == 'Warning') {
        tempWarning[value.FIELDNAME] = value;
        warningData.push(value.ERRORDESCRIPTION);
      }
    });

    if (Object.keys(errorData).length !== 0) {
      localStorage.setItem('confEWshow', 'error');

      this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
        disableClose: true,
        width: DIALOG_WIDTH.FULL,
        data: { errorData: errorData },
      });

      this.confirmDialogRef.componentInstance.confirmMessage = '';

      const result = await this.confirmDialogRef.afterClosed().toPromise();
      localStorage.removeItem('confEWshow');

      if (result) {
      }

      this.confirmDialogRef = null;
    } else if (Object.keys(warningData).length !== 0) {
      localStorage.setItem('confEWshow', 'warning');

      this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
        disableClose: true,
        width: DIALOG_WIDTH.FULL,
        data: warningData,
      });

      this.confirmDialogRef.componentInstance.confirmMessage =
        ApiName == 'SetInvoice' ? '' : 'Are you sure you want to delete?';

      const result = await this.confirmDialogRef.afterClosed().toPromise();
      localStorage.removeItem('confEWshow');

      if (result) {
        await this.toolbarServiceService.DeleteGData(details, ApiName);
      }

      this.confirmDialogRef = null;
    } else if (Object.keys(warningData).length == 0 && Object.keys(errorData).length == 0) {
      await this.toolbarServiceService.DeleteGData(details, ApiName);
    }
  }
}
